export async function withRetry(fn, retries, delay) {
  let retryCount = 0;
  while (retryCount < retries) {
    try {
      return await fn();
    } catch (error) {
      if (retryCount >= retries - 1) {
        throw error;
      }
      if (delay) {
        await new Promise(resolve => setTimeout(resolve, delay));
      }
      retryCount++;
    }
  }
  return undefined;
}
//# sourceMappingURL=with-retry.js.map